import { useTranslation } from "react-i18next";

export type TextDirection = "ltr" | "rtl";

const RTL_LANGUAGES = new Set(["ar"]);

export const getLanguageCode = (language?: string) => (language || "en").split("-")[0].toLowerCase();

export const getTextDirection = (language?: string): TextDirection =>
  RTL_LANGUAGES.has(getLanguageCode(language)) ? "rtl" : "ltr";

export const applyDocumentDirection = (language?: string) => {
  const normalizedLanguage = getLanguageCode(language);
  const direction = getTextDirection(normalizedLanguage);

  document.documentElement.lang = normalizedLanguage;
  document.documentElement.dir = direction;
  document.documentElement.dataset.dir = direction;
  document.documentElement.dataset.language = normalizedLanguage;

  document.body.dir = direction;
  document.body.dataset.dir = direction;
  document.body.dataset.language = normalizedLanguage;

  return direction;
};

export const useTextDirection = () => {
  const { i18n } = useTranslation();
  return getTextDirection(i18n.resolvedLanguage || i18n.language);
};
